import { Components, createTheme, Theme } from "@mui/material/styles";

const baseTheme = createTheme();

const MuiButton: Components<Theme>["MuiButton"] = {
  variants: [
    {
      props: { color: "light", variant: "contained" },
      style: {
        backgroundColor: "#ece8e8",
        color: baseTheme.palette.text.primary,
        "&:hover": {
          backgroundColor: "#d4cfcf",
        },
      },
    },
    {
      props: { color: "light", variant: "outlined" },
      style: {
        color: baseTheme.palette.text.primary,
        borderColor: "#ece8e8",
        "&:hover": {
          backgroundColor: "rgba(236, 232, 232, 0.04)",
          borderColor: "#d4cfcf",
        },
      },
    },
    {
      props: { color: "light", variant: "text" },
      style: {
        color: baseTheme.palette.text.primary,
        "&:hover": {
          backgroundColor: "rgba(236, 232, 232, 0.04)",
        },
      },
    },
  ],
};

export default MuiButton;
